import { createSlice } from "@reduxjs/toolkit";
import { decrypt, formatTime } from "../../utils";
import moment from "moment";

const initialState = {
  loadingCount: true,
  staffLoadingCount: true,
  ordersCount: {
    lasyDayOrders: 0,
    monthOrders: 0,
    todayOrders: 0,
    weekOrders: 0,
  },
  notes: [],
  tasks: [],
  dashboardPendingNotes: [],
  dashboardPendingNotesLoading: false,
  dashboardPendingActions: [],
  dashboardPendingActionsLoading: false,
  dashboardPendingActionsCount: 0,
  dashboardTasksSkypointLoading: false,
  dashboardTasksSkypoint: [],
  dashboardTasksCountSkypoint: 0,
  // Dashboard metrics
  dashboardMetricsLoading: false,
  dashboardMetrics: null,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action?.payload
      };
    },
    setOrdersCount(state, action) {
      return {
        ...state,
        loadingOrdersCount: false,
        ordersCount: action.payload
      };
    },
    setOrdersCountLoading(state, action) {
      return {
        ...state,
        loadingOrdersCount: action.payload
      };
    },

    setDashboardCounts(state, action) {
      return {
        ...state,
        loadingCount: false,
        dashboardCounts: action.payload
      };
    },

    setDashboardNotes(state, action) {
      if (!Array.isArray(action.payload)) {
        return state;
      }
      return {
        ...state,
        loading: false,
        notes: action.payload,
      };
    },
    setDashboardTasks(state, action) {
      if (!Array.isArray(action.payload)) {
        return state;
      }
      return {
        ...state,
        loading: false,
        tasks: action.payload,
      };
    },
    setStaffDashboardCounts(state, action) {
      return {
        ...state,
        staffDashboardCounts: action.payload,
      };
    },
    setDashboardPendingNotes(state, action) {
      return {
        ...state,
        loading: false,
        dashboardPendingNotes: action.payload,
      };
    },
    setDashboardPendingNotesLoading(state, action) {
      return {
        ...state,
        dashboardPendingNotesLoading: action.payload,
      };
    },
    setDashboardPendingActions(state, action) {
      return {
        ...state,
        loading: false,
        dashboardPendingActions: action.payload?.data || [],
        dashboardPendingActionsCount: action.payload?.count || 0,
      };
    },
    setDashboardPendingActionsLoading(state, action) {
       return {
        ...state,
        dashboardPendingActionsLoading: action.payload,
      };
    },
    setStaffLoadingCount(state, action) {
      return {
        ...state,
        staffLoadingCount: action.payload,
      };
    },
    setDashboardTasksSkypointLoading(state, action) {
      return {
        ...state,
        dashboardTasksSkypointLoading: action.payload,
      };
    },
    setDashboardTasksSkypoint(state, action) {
      return {
        ...state,
        dashboardTasksSkypointLoading: false,
        dashboardTasksSkypoint: action.payload?.tasks || [],
        dashboardTasksCountSkypoint: action.payload?.count || 0,
      };
    },
    setDashboardMetricsLoading(state, action) {
      return {
        ...state,
        dashboardMetricsLoading: action.payload,
      };
    },
    setDashboardMetrics(state, action) {
      return {
        ...state,
        dashboardMetricsLoading: false,
        dashboardMetrics: action.payload,
      };
    },
  }
});

export const {
  setOrdersCount,
  setOrdersCountLoading,
  setDashboardCounts,
  setStaffDashboardCounts,
  setDashboardCountLoading,
  setLoading,
  setDashboardNotes,
  setStaffLoadingCount,
  setDashboardPendingNotes,
  setDashboardPendingNotesLoading,
  setDashboardTasks,
  setDashboardPendingActions,
  setDashboardPendingActionsLoading,
  setDashboardTasksSkypointLoading,
  setDashboardTasksSkypoint,
  setDashboardMetricsLoading,
  setDashboardMetrics,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
